
























import Vue from "vue";
export default Vue.extend({
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    inputValue: {
      type: [String, Number],
      required: true
    },
    value: {
      type: [Boolean, Array],
      required: true
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    labelClass: {
      type: String
    }
  },
  computed: {
    model: {
      get(): boolean | Array<any> {
        return this.value;
      },
      set(e: string | number): void {
        this.$emit("change", e);
      }
    },
    checked(): boolean {
      if (Array.isArray(this.value)) {
        return (this.value as any[]).includes(this.inputValue);
      } else {
        return this.value;
      }
    }
  }
});
